<script lang="ts">
    import {getInjector} from 'src/core';
    import type {SearchParams, StaticSearchParams} from 'src/typings';
    import {setSearchContext, tryToConnectSearchManagerToProxy} from './search-context';
    import {SearchManagerBuilderFactoryService} from '../search-manager/search-manager-factory.service';

    export let staticParams: Partial<StaticSearchParams> | undefined;
    export let localSearch = false;
    const service = getInjector().getByClass(SearchManagerBuilderFactoryService);

    const searchManagerBuilder = service.createBuilder<SearchParams, any>().withStaticParams(staticParams);
    const searchManager = localSearch ? searchManagerBuilder.createLocalSearch(true) : searchManagerBuilder.createGlobalSearch();

    setSearchContext(searchManager);

    tryToConnectSearchManagerToProxy(searchManager);
</script>

<slot {searchManager}/>